module.exports = "/_next/static/images/gradient-86cd560cf3051456161726a9a301e315.jpg";